export const csrfToken = () => {
  let csrf = ''
  if (typeof window === 'undefined' || !window.document) return csrf
  let element: HTMLInputElement | null = document.querySelector('input#csrftoken')
  if (element !== null) {
    csrf = element.value
  }
  return csrf
}
